import { useContext } from 'react'
import { DynamicPowerPricesEnabledContext } from 'src/Libs/dynamic-power-prices/context/dynamic-power-prices-enabled-context'
import { useWallboxes } from 'src/Libs/wallboxes'
import { WallboxType } from 'src/Libs/wallboxes/dto'

/**
 * a hook that returns condition for sunmode disabled banner
 */
const useSunModeDisabledBannerConditions = (): boolean => {
  const { isDynamicPowerPriceEnabledForWallboxes } = useContext(DynamicPowerPricesEnabledContext)
  const { wallboxes } = useWallboxes()

  const isBannerVisible =
    isDynamicPowerPriceEnabledForWallboxes &&
    wallboxes.some(wallbox => wallbox.isAvailable && wallbox.wallboxType !== WallboxType.Bidi && wallbox.sunModeActive === false)

  return isBannerVisible
}

export default useSunModeDisabledBannerConditions
